module.exports = __webpack_public_path__ + "img/foto-kerjasama-3.c85f4696.jpeg";